import { render, staticRenderFns } from "./home.vue?vue&type=template&id=4b4788d5&scoped=true&"
import script from "./home.ts?vue&type=script&lang=js&"
export * from "./home.ts?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=4b4788d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4788d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
